<section class="has-padding-block-1 animated fadeIn">
  <div class="row">
    <div class="col-sm-3 d-none d-sm-block">
      <img src="../../../assets/images/landing/moving-towards-zero-waste/zero-waste.webp" class="img-side is-height-2"
        alt="Sustainable Packaging image">
    </div>
    <div class="col-sm-9">
      <h2 class="section-title">Creating a more sustainable food system</h2>
      <p>Our food system generates a lot of trash, carbon and food waste. Many grocery delivery companies are some of
        the biggest offenders. We combat these issues by prioritizing growers using regenerative agriculture methods,
        decreasing carbon emission throughout our supply chain, using reusable packaging, and making sure no food ends
        in a landfill. Read more about some of the specifics below.</p>
    </div>
    <div class="col-sm-3 d-block d-sm-none">
      <img src="../../../assets/images/landing/moving-towards-zero-waste/zero-waste.webp" class="img-side is-height-2"
        alt="Sustainable Packaging image">
    </div>
  </div>
</section>
<div class="banner-title-wrap is-center mt-3 mb-5">
  <div class="banner-title is-primary ">“We make high-quality, sustainably produced food
    available to consumers year-round.”
  </div>
</div>
<hr class="is-thick">
<div>
  <h2 class="section-title">Sustainable Packaging</h2>

  <h3 class="h3-bold">Minimal packaging</h3>
  <p>Cauliflower wrapped in plastic? Weird. To cut down on needless bags and containers, we don’t package large fruits
    and vegetables that don’t need them. We also use paper to package whenever possible. We have had to build internal
    systems as well as work with farmers to make this possible.</p>
  <p>Here is how we do it:</p>
  <ul class="ul-checklist">
    <li>Train staff to assemble the boxes to keep tender items protected in transit so they don’t require additional
      packaging</li>
    <li>Create an item labeling system to denote the different items packed in paper bags</li>
    <li>Refrigerated trucks so each box does not have to be insulated</li>
  </ul>

  <div>
    <h3 class="h3-bold">Reusing boxes and other packing materials</h3>
    <p>Unlike most other grocery delivery companies, we offer customers the option of returning packaging when we drop
      off new orders.</p>
    <p>These items include:</p>
    <ul class="ul-checklist">
      <li>Wax-coated boxes</li>
      <li>Ice packs</li>
      <li>Post-consumer recycled plastic clamshells for our baby greens</li>
      <li>Glass milk bottles</li>
      <li>Fishtown Pickle Project jars</li>
    </ul>
    <p>After we process them for damage and contamination, these materials are reused for the next week’s orders,
      reducing the amount of trash left in customers’ bins.</p>
  </div>

  <div>
    <h3 class="h3-bold">Using 99% recyclable packing materials</h3>
    <p>We have worked extensively with our packaging supplier to identify post-consumer recycled packaging and find
      replacements for single-use packaging.</p>
    <p>This includes:</p>
    <ul class="ul-checklist">
      <li>Paper bags for storage crops</li>
      <li>Thick paper packaging to support fragile products in boxes</li>
      <li>Paper pulp quart containers for fragile fruit</li>
      <li>Uncoated butcher paper for fragile tomatoes</li>
    </ul>
    <p>All of these items can be recycled in your municipalities or repurposed. We encourage you to do so!</p>
  </div>
</div>
<hr class="is-thick">
<div>
  <h2 class="section-title">Reducing food waste in landfills</h2>
  <div>
    <h3 class="h3-bold">Selling mildly damaged and “ugly” produce at a discount</h3>
    <p>Rather than composting fruits and vegetables that have minor bruises or dings or are nearing over-ripeness, we
      offer them in our market as “seconds” priced at a bulk discount. (They're still delicious but meant to be
      processed right away.) Similarly, if the produce our farmers harvest is oddly shaped or has an unappealing
      appearance, we take those items at a slightly lower price and pass the savings to our customers in the market. We
      also see this as a way to teach people in our community that nutritious, sustainably grown local produce comes in
      all shapes and sizes.</p>
  </div>
  <div>
    <h3 class="h3-bold">Composting</h3>
    <p>Anything that is not edible is stored in our compost bins throughout the week. The following week when we pick up
      produce at our partner farms we back haul this food waste to their farms so that it can be turned into compost and
      used to grow more food. It really is a closed loop!</p>
  </div>
</div>
<hr class="is-thick">
<div>
  <h2 class="section-title">Reducing carbon emissions in our supply chain</h2>
  <div>
    <h3 class="h3-bold">100% renewable energy </h3>
    <p>our warehouse is powered by 100% renewable energy. We are also planning on installing solar panels on our roof!
    </p>
  </div>
  <div>
    <h3 class="h3-bold">Efficient delivery routes</h3>
    <p>We limit the delivery days and delivery times we go to each neighborhood so that way we can consolidate our
      deliveries by area and decrease the overall amount of miles driven per delivery. In fact, we average 1.1
      miles/delivery which includes the distance to and from our warehouse. The national average round trip to the
      grocery store is approximately 8 miles.</p>
  </div>

  <div>
    <h2 class="h3-bold">Efficient transportation routes</h2>
    <p>We have established a network of aggregation hubs where multiple farmers in certain areas can deliver products to
      be transported in consolidated deliveries to our warehouse in Philadelphia. And we cover the cost of trucking!
      This not only reduces the carbon footprint and allows smaller farmers to access the city market, but it also
      allows farmers to keep more of their profits to invest back in their business.</p>
  </div>
</div>